<template>
  <div id="engagementPulse">
    <Pulse
      v-if="pulse.pulse1 || pulse.pulse2 || pulse.pulse3"
      :pulse.sync="pulse"
      :pulse-report="pulseReport"
    />
  </div>
</template>

<script>
import api from '@/api';
import Pulse from './Pulse.vue';

export default {
  name: 'PulseMain',

  components: {
    Pulse,
  },

  data: () => ({
    activatedPulse: 1,
    pulse: {
      pulse1: null,
      pulse2: null,
      pulse3: null,
    },
    pulseReport: null,
  }),

  created() {
    this.getEngagementPulse();
    this.getEngagementPulseReport();
  },

  methods: {
    async getEngagementPulse() {
      try {
        this.loading = true;
        const response = await api.getPulseEngagement();

        this.pulse = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementPulseReport() {
      try {
        this.loading = true;
        const response = await api.getPulseReportLeader({ quick: true });

        this.pulseReport = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
